(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eluna-city-signatures"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('eluna-city-signatures')){customElements.define('eluna-city-signatures',class extends HTMLElement{
connectedCallback(){if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;this.panels=[...this.querySelectorAll('.ecs-panel')];this.buttons=[...this.querySelectorAll('[data-city]')];this.index=0;this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.dataset.autoplay!=='true'||this.motion.matches;this.visible=false;this.hovered=false;this.focused=false;this.querySelector('.ecs-controls').hidden=false;this.dataset.ready='';this.show(0);this.buttons.forEach((button,index)=>button.addEventListener('click',()=>{this.paused=true;this.show(index);this.sync();},{signal}));this.querySelector('[data-prev]').addEventListener('click',()=>{this.paused=true;this.show(this.index-1);this.sync();},{signal});this.querySelector('[data-next]').addEventListener('click',()=>{this.paused=true;this.show(this.index+1);this.sync();},{signal});this.querySelector('[data-toggle]').addEventListener('click',()=>{this.paused=!this.paused;this.sync();},{signal});this.addEventListener('mouseenter',()=>{this.hovered=true;this.sync();},{signal});this.addEventListener('mouseleave',()=>{this.hovered=false;this.sync();},{signal});this.addEventListener('focusin',()=>{this.focused=true;this.sync();},{signal});this.addEventListener('focusout',event=>{if(!this.contains(event.relatedTarget)){this.focused=false;this.sync();}},{signal});document.addEventListener('visibilitychange',()=>this.sync(),{signal});this.motion.addEventListener('change',()=>{if(this.motion.matches)this.paused=true;this.sync();},{signal});document.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('.ecs-panel');if(panel&&this.contains(panel)){this.paused=true;this.show(this.panels.indexOf(panel));this.sync();}},{signal});this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync();},{threshold:.15});this.observer.observe(this);this.sync();}
show(index){this.index=(index+this.panels.length)%this.panels.length;this.panels.forEach((panel,i)=>{panel.classList.toggle('is-active',i===this.index);panel.inert=i!==this.index;panel.setAttribute('aria-hidden',String(i!==this.index));this.buttons[i].setAttribute('aria-pressed',String(i===this.index));});}
sync(){clearInterval(this.timer);const control=this.querySelector('[data-toggle]');control.setAttribute('aria-label',this.paused?this.dataset.play:this.dataset.pause);this.querySelector('[data-pause-icon]').hidden=this.paused;this.querySelector('[data-play-icon]').hidden=!this.paused;if(!this.paused&&this.visible&&!this.hovered&&!this.focused&&!document.hidden&&!window.Shopify?.designMode)this.timer=setInterval(()=>this.show(this.index+1),Number(this.dataset.speed)*1000);}
disconnectedCallback(){clearInterval(this.timer);this.observer?.disconnect();this.abort?.abort();this.abort=null;}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eluna-signature-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('eluna-signature-hero')) {
    class ELunaSignatureHero extends HTMLElement {
      connectedCallback() {
        this.slideshow = this.querySelector('slideshow-component');
        this.slider = this.querySelector('[id^="Slider-"]');
        this.slides = Array.from(this.querySelectorAll('[id^="Slide-"]'));
        this.activeIndex = 0;
        this.resizeTimer = null;
        this.isResizing = false;
        this.controlButtons = Array.from(this.querySelectorAll('.slider-button[name]'));

        if (!this.slideshow || !this.slider || this.slides.length < 2) return;

        this.handleSlideChange = this.handleSlideChange.bind(this);
        this.handleControlClick = this.handleControlClick.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.slideshow.addEventListener('slideChanged', this.handleSlideChange);
        this.controlButtons.forEach((button) => button.addEventListener('click', this.handleControlClick));
        window.addEventListener('resize', this.handleResize, { passive: true });
      }

      disconnectedCallback() {
        if (!this.slideshow) return;
        this.slideshow.removeEventListener('slideChanged', this.handleSlideChange);
        this.controlButtons.forEach((button) => button.removeEventListener('click', this.handleControlClick));
        window.removeEventListener('resize', this.handleResize);
        clearTimeout(this.resizeTimer);
      }

      handleSlideChange(event) {
        if (this.isResizing || !event.detail || !event.detail.currentElement) return;
        const nextIndex = this.slides.indexOf(event.detail.currentElement);
        if (nextIndex >= 0) this.activeIndex = nextIndex;
      }

      handleControlClick(event) {
        const increment = event.currentTarget.name === 'next' ? 1 : -1;
        this.activeIndex = (this.activeIndex + increment + this.slides.length) % this.slides.length;
      }

      handleResize() {
        this.isResizing = true;
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          const activeSlide = this.slides[this.activeIndex];
          if (!activeSlide) return;

          this.slider.scrollTo({ left: activeSlide.offsetLeft, behavior: 'auto' });
          this.slideshow.currentPage = this.activeIndex + 1;
          this.slideshow.setSlideVisibility();

          const currentCounter = this.querySelector('.slider-counter--current');
          if (currentCounter) currentCounter.textContent = this.activeIndex + 1;
          this.isResizing = false;
        }, 150);
      }
    }

    customElements.define('eluna-signature-hero', ELunaSignatureHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
